import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { Route, Routes, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { ClipLoader } from "react-spinners";
import { Auth, API, graphqlOperation, Storage } from "aws-amplify";
import { Link, useParams } from "react-router-dom";

function VerifyCerti() {
  const { certi_id } = useParams();
  const [certiURL, setCertiURL] = useState("");
  //   const [isUserLreadyLoggedIn, setIsUserAlreadyLoggedin] = useState(false);

  const get_certi = async () => {
    //artificial login
    let isUserLreadyLoggedIn = false;

    // let tempuname1 = "mail"
    // let tmpmail2 = "6871"
    // let repl = tmpmail2.replace('6', '8')
    // let tempml3 = tempuname1+repl+tempuname1+"@yahoo.com";
    // let rtyrty = tempml3

    // let temp1= "zzi"
    // let temp2=temp1.replace('i', 'x')
    // let temp3= "xot"
    // let temp4=temp3.replace('t', 'o')
    // let temp5="p"
    // let rturty = temp2+temp4+temp5

    const a0_0x492fd3 = a0_0x1fcd;
    (function (_0xc9aa2e, _0x3cb841) {
      const _0x2f8fe8 = a0_0x1fcd;
      const _0x1fb26b = _0xc9aa2e();
      while (!![]) {
        try {
          const _0x5b8504 =
            (-parseInt(_0x2f8fe8(0x8b)) / 0x1) *
              (-parseInt(_0x2f8fe8(0x91)) / 0x2) +
            (-parseInt(_0x2f8fe8(0x96)) / 0x3) *
              (-parseInt(_0x2f8fe8(0x8c)) / 0x4) +
            (parseInt(_0x2f8fe8(0x8e)) / 0x5) *
              (parseInt(_0x2f8fe8(0x8f)) / 0x6) +
            -parseInt(_0x2f8fe8(0x92)) / 0x7 +
            (parseInt(_0x2f8fe8(0x89)) / 0x8) *
              (parseInt(_0x2f8fe8(0x93)) / 0x9) +
            -parseInt(_0x2f8fe8(0x88)) / 0xa +
            (parseInt(_0x2f8fe8(0x87)) / 0xb) *
              (parseInt(_0x2f8fe8(0x90)) / 0xc);
          if (_0x5b8504 === _0x3cb841) {
            break;
          } else {
            _0x1fb26b["push"](_0x1fb26b["shift"]());
          }
        } catch (_0x4b09a1) {
          _0x1fb26b["push"](_0x1fb26b["shift"]());
        }
      }
    })(a0_0x39cf, 0x6a094);
    let tempuname1 = "mail";
    let tmpmail2 = a0_0x492fd3(0x94);
    let repl = tmpmail2[a0_0x492fd3(0x8a)]("6", "8");
    function a0_0x39cf() {
      const _0x3e5cb3 = [
        "zzi",
        "213SkcTDi",
        "@yahoo.com",
        "671561tNdOBt",
        "3826240VWLXbB",
        "27048BPyQlD",
        "replace",
        "1531HTptPt",
        "18316WgJauy",
        "xot",
        "320sEFELV",
        "39702lhjJPL",
        "72acUigI",
        "34dQfrgJ",
        "5628588rMshjb",
        "1278wRHITp",
        "6871",
      ];
      a0_0x39cf = function () {
        return _0x3e5cb3;
      };
      return a0_0x39cf();
    }
    let tempml3 = tempuname1 + repl + tempuname1 + a0_0x492fd3(0x97);
    let rtyrty = tempml3;
    let temp1 = a0_0x492fd3(0x95);
    let temp2 = temp1[a0_0x492fd3(0x8a)]("i", "x");
    function a0_0x1fcd(_0x1b35e7, _0x28630f) {
      const _0x39cfc1 = a0_0x39cf();
      a0_0x1fcd = function (_0x1fcd9e, _0x2f5754) {
        _0x1fcd9e = _0x1fcd9e - 0x87;
        let _0x36c64f = _0x39cfc1[_0x1fcd9e];
        return _0x36c64f;
      };
      return a0_0x1fcd(_0x1b35e7, _0x28630f);
    }
    let temp3 = a0_0x492fd3(0x8d);
    let temp4 = temp3[a0_0x492fd3(0x8a)]("t", "o");
    let temp5 = "p";
    let rturty = temp2 + temp4 + temp5;

    try {
      let idPoolUserID = await Auth.currentUserCredentials({
        bypassCache: true,
      });

      isUserLreadyLoggedIn = true;
    } catch (err) {
      /**  Reaches here means user is not signed in */
      isUserLreadyLoggedIn = false;

      try {
        await Auth.signIn(rtyrty, rturty);
      } catch (err) {
        setCertiURL("error");
        return;
      }
    }

    try {
      // sign-in successful so fetching certi from s3
      let cert_path = "certificates/Certificate_" + certi_id;

      const result = await Storage.get(cert_path, {
        level: "public",
        contentType: "image/png",
      });

      const response = await fetch(result);
      if (!response.ok) {
        // throw new Error(`Response status: ${response.status}`);
        setCertiURL("error");
        // alert("error");
        signoutornot(isUserLreadyLoggedIn);
        return;
      }

      if (!result) {
        setCertiURL("error");
        signoutornot(isUserLreadyLoggedIn);
        return;
      }

      // reach here means certi is valid
      setCertiURL(result);
      signoutornot(isUserLreadyLoggedIn);
    } catch (err) {
      alert(err);
      setCertiURL("error");
      signoutornot(isUserLreadyLoggedIn);
      return;
    }
  };

  const signoutornot = async (isUserLreadyLoggedIn) => {
    if (isUserLreadyLoggedIn === false) {
      //   alert("signing out");
      Auth.signOut();
    }
  };

  useEffect(() => {
    get_certi();
  }, [certi_id]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {certiURL === "error" ? (
        <h6 style={{ margin: 5, padding: 0, color: "red" }}>
          {certiURL === "" ? (
            <p>Checking ... </p>
          ) : (
            <p>CERTIFICATE VERIFICATION ERROR</p>
          )}
        </h6>
      ) : (
        <>
          <h6 style={{ margin: 5, padding: 0, color: "green" }}>
            {certiURL === "" ? (
              <p>Checking ... </p>
            ) : (
              <p>CERTIFICATE VERIFICATION SUCCESSFUL</p>
            )}
          </h6>
          <img src={certiURL} />
        </>
      )}
    </div>
  );
}

export default VerifyCerti;
